import { useTranslation } from 'react-i18next'
import { ThemeToggleButton } from '../components/ThemeToggleButton'
import { LanguageSelector } from '../components/LanguageSelector'

/**
 * Terminal "no Studio entitlement" screen (MS-682 Scenario A). Reuses the
 * login screen's chrome exactly (backdrop, logo, card, theme/language
 * controls) but offers no action — re-authenticating cannot resolve a
 * missing entitlement.
 */
export function AccessDenied() {
  const { t } = useTranslation()

  return (
    <div className="login-screen">
      <div className="login-controls">
        <ThemeToggleButton />
        <LanguageSelector />
      </div>

      <div className="login-logo">
        <img src="/mambu-logo.png" alt="Mambu" />
      </div>

      <div className="login-card">
        <h2>{t('login.brand')}</h2>
        <div className="login-brand">{t('login.brandSub')}</div>
        <div className="login-denied-badge">{t('accessDenied.badge')}</div>
        <div className="login-subtitle">{t('accessDenied.message')}</div>
      </div>
    </div>
  )
}
